import React from "react"
import { motion } from "framer-motion"
import { Row, Col } from "react-flexbox-grid"
import styled, { css } from "styled-components"
import { rem } from "polished"

import Container from "../container"
import BackgroundTexture from "../background-texture"

import { BerlinTime, LaTime } from "../time-zones/times"

const TimeZoneTextWrapper = styled.div`
  overflow: hidden;

  @media ${props => props.theme.desktopDown} {
    font-size: ${rem(13)};
  }
`

const TimeZonesContainer = styled(Container)`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  left: 2.5%;
  z-index: -1;

  ${props =>
    props.textColor &&
    css`
      color: ${props => props.textColor};
    `}

  .row {
    height: 100%;
    align-items: center;
  }
`

const BackgroundImageContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: -1;

  & > div {
    height: 100vh;
  }
`

const TimeZones = ({ timesVisible, color }) => (
  <React.Fragment>
    <BackgroundImageContainer>
      <BackgroundTexture />
    </BackgroundImageContainer>

    <TimeZonesContainer textColor={color}>
      <Row>
        <Col lg={2} lgOffset={2} md={2} mdOffset={1}>
          <TimeZoneTextWrapper>
            <motion.div
              initial={{ opacity: 0, y: "100%" }}
              animate={
                timesVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: "100%" }
              }
              transition={{ duration: 0.4, delay: 0 }}
            >
              BERLIN
            </motion.div>
          </TimeZoneTextWrapper>

          <TimeZoneTextWrapper>
            <motion.div
              initial={{ opacity: 0, y: "100%" }}
              animate={
                timesVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: "100%" }
              }
              transition={{ duration: 0.4, delay: 0.1 }}
            >
              <BerlinTime />
            </motion.div>
          </TimeZoneTextWrapper>
        </Col>

        <Col lg={2} lgOffset={5} md={2} mdOffset={6}>
          <TimeZoneTextWrapper>
            <motion.div
              initial={{ opacity: 0, y: "100%" }}
              animate={
                timesVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: "100%" }
              }
              transition={{ duration: 0.4, delay: 0.2 }}
            >
              LOS ANGELES
            </motion.div>
          </TimeZoneTextWrapper>

          <TimeZoneTextWrapper>
            <motion.div
              initial={{ opacity: 0, y: "100%" }}
              animate={
                timesVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: "100%" }
              }
              transition={{ duration: 0.4, delay: 0.3 }}
            >
              <LaTime />
            </motion.div>
          </TimeZoneTextWrapper>
        </Col>
      </Row>
    </TimeZonesContainer>
  </React.Fragment>
)

export default TimeZones
